<div class="b2a-achievementContainer">
  <div class="b2a-achievementContainer__header">
    {{ 'ACHIEVEMENTS.title' | translate }}

    <app-chips-list-notResponsive class="tab-indicator">
      <!--  <app-chip-notResponsive (select)="toggleAll()" selected="true">Alle</app-chip-notResponsive>
      <app-chip-notResponsive (select)="toggleLocked()">Offen</app-chip-notResponsive>
      <app-chip-notResponsive (select)="toggleUnlocked()">Freigeschaltet</app-chip-notResponsive> -->

      <app-chip-notResponsive (select)="showHelpPage()" selected="true">{{ 'ACHIEVEMENTS.info' | translate }}</app-chip-notResponsive>
    </app-chips-list-notResponsive>
  </div>

  <div class="b2a-achievementContainer__inner">
    <div class="row" *ngFor="let chunk of achievementChunks">
      <div class="col-sm-2" *ngFor="let achievement of chunk">
        <div class="achievement-card">
          <div class="achievement-icon">
            <app-achivement-progress
              [progress]="this.getProgressPercentage(achievement)"
              [color]="this.getProgressColor(achievement)"
              [name]="achievement.name"
            ></app-achivement-progress>
            <img
              src="assets/icons/achivement/unlocked/versteckt.svg"
              alt="{{ 'ACHIEVEMENTS.hiddenAchievement' | translate }}"
              *ngIf="this.getCurrentAchievementLevel(achievement) == 'unlocked' && achievement.hiddenAchievement"
            />
            <img
              src="assets/icons/achivement/unlocked/{{ achievement.icon }}"
              alt="{{ translateAchievementName(achievement.name) }}"
              *ngIf="this.getCurrentAchievementLevel(achievement) == 'unlocked' && !achievement.hiddenAchievement"
            />
            <img
              src="assets/icons/achivement/green/{{ achievement.icon }}"
              alt="{{ translateAchievementName(achievement.name) }}"
              *ngIf="this.getCurrentAchievementLevel(achievement) == 'green'"
            />
            <img
              src="assets/icons/achivement/bronze/{{ achievement.icon }}"
              alt="{{ translateAchievementName(achievement.name) }}"
              *ngIf="this.getCurrentAchievementLevel(achievement) == 'bronze'"
            />
            <img
              src="assets/icons/achivement/silber/{{ achievement.icon }}"
              alt="{{ translateAchievementName(achievement.name) }}"
              *ngIf="this.getCurrentAchievementLevel(achievement) == 'silber'"
            />
            <img
              src="assets/icons/achivement/gold/{{ achievement.icon }}"
              alt="{{ translateAchievementName(achievement.name) }}"
              *ngIf="this.getCurrentAchievementLevel(achievement) == 'gold'"
            />
            <!-- Add a span element to hold the progress text -->
            <span
              [style.color]="this.getProgressColor(achievement)"
              class="progress-text"
              *ngIf="achievement.hasLevels == true && this.getCurrentAchievementLevel(achievement) != 'gold'"
            >
              {{ this.getProgressString(achievement) }}
            </span>
          </div>
          <div class="achievement-name">
            {{
              this.getCurrentAchievementLevel(achievement) == 'unlocked' && achievement.hiddenAchievement
                ? ('ACHIEVEMENTS.hiddenAchievement' | translate)
                : translateAchievementName(achievement.name)
            }}
          </div>
          <div class="achievement-description">
            {{
              this.getCurrentAchievementLevel(achievement) == 'unlocked' && achievement.hiddenAchievement
                ? '???'
                : translateAchievementDescription(achievement.name)
            }}
          </div>
          <!--<p>{{ this.getCurrentAchievementLevel(achievement).currentLevel != 'gold' ?  this.getProgressPercentage(achievement) : "100" }}%</p>-->
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/achievement/achievement.component.html